import { interval } from 'rxjs';
import { startWith } from 'rxjs/operators';

import request from '@utils/axiosWrapper';
import * as Ids from '@utils/ids';

import { addOrderNotification } from '../../eventHandler/pushNotification';

const POLLING_INTERVAL = 5 * 60 * 1000;

/** 超时取消订单通知轮询 */
const init = () => {
    interval(POLLING_INTERVAL)
        .pipe(startWith(0))
        .subscribe(() => {
            request
                .get<{ cancelReason: string }>('/v2/order/history/r/timeoutCancelOrder/notify', {
                    params: {
                        wmPoiId: Ids.getWmPoiId(),
                        source: 1,
                    },
                })
                .then(
                    res => {
                        if (res.cancelReason) {
                            addOrderNotification({ content: res.cancelReason });
                        }
                    },
                    () => {
                        // NOTE: 大连锁账号超时报错，静默处理
                    },
                );
        });
};

export default { init };
